import { render, staticRenderFns } from "./rule-form-tab3.vue?vue&type=template&id=6282d390&scoped=true&"
import script from "./rule-form-tab3.vue?vue&type=script&lang=ts&"
export * from "./rule-form-tab3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6282d390",
  null
  
)

export default component.exports